<div class="page-wrap">
<h2>Kulrs.com Privacy Policy</h2>

<p>This privacy policy will explain how we use the personal data we collect from you when you use our website.</p>
<p>Topics:</p>
<ul>
    <li>What data do we collect?</li>
    <li>How do we collect your data?</li>
    <li>How will we use your data?</li>
    <li>What are your data protection rights?</li>
    <li>What are cookies?</li>
    <li>How do we use cookies?</li>
    <li>What types of cookies do we use?</li>
    <li>How to manage your cookies</li>
    <li>Privacy policies of other websites</li>
    <li>Changes to our privacy policy</li>
    <li>How to contact us</li>
</ul>

<h3>What data do we collect?</h3>
<p>Our Company collects the following data:</p>
<ul>
    <li>Personal identification information (Name, email address, phone number, etc.)</li>
</ul>

<h3>How do we collect your data?</h3>
<p>You directly provide Our Company with most of the data we collect. We collect data and process data when you:</p>
<ul>
    <li>Register online or place an order for any of our products or services.</li>
    <li>Voluntarily complete a customer survey or provide feedback on any of our message boards or via email.</li>
    <li>Use or view our website via your browser’s cookies.</li>
</ul>
<p>Our Company may also receive your data indirectly from the following sources</p>
<p>We receive information about you from other Service users, from third-party services, from our related companies,
    social media platforms, public databases, and from our business and channel partners. We may combine this
    information with information we collect through other means described above. This helps us to update and improve our
    records, identify new customers, create more personalized advertising and suggest services that may be of interest
    to you.</p>

<h3>How will we use your data?</h3>

<p>Our Company collects your data so that we can:</p>
<ul>
    <li>Process your order and manage your account.</li>
    <li>Email you with special offers on other products and services we think you might like.</li>
</ul>

<h3>What are your data protection rights?</h3>

<p>Our Company would like to make sure you are fully aware of all of your data protection rights. Every user is entitled
    to the following:</p>
<p>
    <strong>The right to access</strong> &#8211; You have the right to request Our Company for copies of your personal
    data. We may charge you a small fee for this service.</p>
<p>
    <strong>The right to rectification</strong> &#8211; You have the right to request that Our Company correct any
    information you believe is inaccurate. You also have the right to request Our Company to complete the information
    you believe is incomplete.</p>
<p>
    <strong>The right to erasure</strong> – You have the right to request that Our Company erase your personal data,
    under certain conditions.</p>
<p>
    <strong>The right to restrict processing</strong> &#8211; You have the right to request that Our Company restrict
    the processing of your personal data, under certain conditions.</p>
<p>
    <strong>The right to object to processing</strong> &#8211; You have the right to object to Our Company’s processing
    of your personal data, under certain conditions.</p>
<p>
    <strong>The right to data portability</strong> &#8211; You have the right to request that Our Company transfer the
    data that we have collected to another organization, or directly to you, under certain conditions.</p>
<p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please
    contact us at our email: support@kulrs.com</p>

<h3>Cookies</h3>

<p>Cookies are text files placed on your computer to collect standard Internet log information and visitor behavior
    information. When you visit our websites, we may collect information from you automatically through cookies or
    similar technology</p>

<h3>How do we use cookies?</h3>

<p>Our Company uses cookies in a range of ways to improve your experience on our website, including:</p>
<ul>
    <li>Keeping you signed in</li>
    <li>Understanding how you use our website</li>
</ul>

<h3>What types of cookies do we use?</h3>
<p>There are a number of different types of cookies, however, our website uses:</p>
<ul>
    <li>Functionality – Our Company uses these cookies so that we recognize you on our website and remember your
        previously selected preferences. These could include what language you prefer and location you are in. A mix of
        first-party and third-party cookies are used.
    </li>
</ul>

<h3>How to manage cookies</h3>
<p>You can set your browser not to accept cookies, and the above website tells you how to remove cookies from your
    browser. However, in a few cases, some of our website features may not function as a result.</p>

<h3>Privacy policies of other websites</h3>
<p>The Our Company website contains links to other websites. Our privacy policy applies only to our website, so if you
    click on a link to another website, you should read their privacy policy.</p>

<h3>Changes to our privacy policy</h3>
<p>Our Company keeps its privacy policy under regular review and places any updates on this web page. This privacy
    policy was last updated on 2 February 2022.</p>

<h3>How to contact us</h3>

<p>If you have any questions about Our Company’s privacy policy, the data we hold on you, or you would like to exercise
    one of your data protection rights, please do not hesitate to contact us.</p>
<p>Email us at: support@kulrs.com</p>
</div>

<style>
    h2, h3 {
        color: #AAFFDD;
    }
    .page-wrap {
        color: #FBF8FE;
        display: flex;
        flex: 1;
        flex-direction: column;
        align-content: center;
        margin: 5vw;
        padding: 2vw;
    }
</style>
